import React from 'react';
import { Col } from 'antd';
import type { ColProps } from 'antd';

export type AppColProps = ColProps;

const AppCol = React.forwardRef<HTMLDivElement, AppColProps>((props, ref) => {
  return <Col ref={ref} {...props} />;
});

AppCol.displayName = 'AppCol';

export default AppCol;
